import { render, staticRenderFns } from "./IngresoEgresoView.vue?vue&type=template&id=6a56a546"
import script from "./IngresoEgresoView.vue?vue&type=script&lang=js"
export * from "./IngresoEgresoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports